import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema";

import {
  agentIdAndNameAreValid,
  assignmentIsUnique,
  mediaTypeIsValid,
  queueIdAndNameAreValid,
} from "./schemaValidations";

import MediaTypes from "../types/mediaTypes";

const schema = yup
  .object({
    tapId: yup.string(),
    agentId: yup.string().requiredIfEmpty("agentName").nullable(),
    agentName: yup.string().requiredIfEmpty("agentId").nullable(),
    queueId: yup.string().requiredIfEmpty("queueName").nullable(),
    queueName: yup.string().requiredIfEmpty("queueId").nullable(),
    mediaType: yup.string().nullable().oneOf(Object.values(MediaTypes)),
    isEnabled: yup.boolean().required(),
    skillLevel: yup
      .number()
      .integer()
      .min(10)
      .max(100)
      .test(
        "multiple of 10",
        `Must be a multiple of 10 in the range [10, 100]`,
        (value) => value % 10 === 0
      )
      .required(),
  })
  .test(
    "agent ID and name legitimate",
    "Agent ID and name must refer to the same agent",
    agentIdAndNameAreValid
  )
  .test(
    "queue ID and name legitimate",
    "Queue ID and name must refer to the same queue",
    queueIdAndNameAreValid
  )
  .test("unique assignment", `Assignment must be unique`, assignmentIsUnique)
  .test(
    "media type legitimate",
    "Media type must correspond with queue",
    mediaTypeIsValid
  );

export default addKeyToFieldsRecursively(schema);
